import { canadaZipCodeRegex, usaZipCodeRegex } from '../../../../utils/constants';

export const zipCodeRegex = new RegExp(usaZipCodeRegex.source + '|' + canadaZipCodeRegex.source);
